import { addDays, addWeeks } from 'date-fns'
import { TZDate } from '@date-fns/tz'
import { isSameDay } from 'date-fns'

const createObservedHoliday = (
  month: number,
  day: number,
  year: number
): TZDate => {
  const base = new TZDate(
    `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(
      2,
      '0'
    )}T00:00:00`,
    'America/New_York'
  )
  const weekday = base.getDay()

  if (weekday === 6) {
    return new TZDate(addDays(base, -1), 'America/New_York')
  } else if (weekday === 0) {
    return new TZDate(addDays(base, 1), 'America/New_York')
  }

  return base
}

export const getQuickboxHolidays = (year: number): TZDate[] => {
  let memorial = new TZDate(`${year}-05-31T00:00:00`, 'America/New_York')
  while (memorial.getDay() !== 1) {
    memorial = new TZDate(addDays(memorial, -1), 'America/New_York')
  }
  const independence = createObservedHoliday(7, 4, year)

  let labor = new TZDate(`${year}-09-01T00:00:00`, 'America/New_York')
  while (labor.getDay() !== 1) {
    labor = new TZDate(addDays(labor, 1), 'America/New_York')
  }

  let thanksgivingBase = new TZDate(
    `${year}-11-01T00:00:00`,
    'America/New_York'
  )
  while (thanksgivingBase.getDay() !== 4) {
    thanksgivingBase = new TZDate(
      addDays(thanksgivingBase, 1),
      'America/New_York'
    )
  }
  const thanksgiving = new TZDate(
    addWeeks(thanksgivingBase, 3),
    'America/New_York'
  )

  const christmas = createObservedHoliday(12, 25, year)

  return [memorial, independence, labor, thanksgiving, christmas]
}

export const isHoliday = (date: Date): boolean => {
  const tzDate =
    date instanceof TZDate ? date : new TZDate(date, 'America/New_York')
  const holidays = getQuickboxHolidays(tzDate.getFullYear())
  return holidays.some((holiday) => isSameDay(holiday, tzDate))
}

export const addTransitDays = (start: Date, days: number): Date => {
  return addDays(start, days)
}
